import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Login.css";
import LEGAL_CONFIG from "../config/legalConfig";
import { useLanguage } from "../context/LanguageContext";
import { t } from "../i18n";
import { FlagTH, FlagUS } from "../components/FlagIcon";
import API from "../config";

function nowThaiTime() {
  const now = new Date();
  const offset = 7 * 60;
  const thai = new Date(now.getTime() + offset * 60 * 1000);
  return thai.toISOString().replace("Z", "+07:00");
}

function buildText(doc) {
  return doc.sections.map(s => s.heading + "\n" + s.body).join("\n\n");
}

function TermsModal({ title, content, onClose }) {
  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}
      onClick={onClose}
    >
      <div
        style={{ background: "rgba(255,255,255,0.95)", backdropFilter: "blur(20px)", borderRadius: "20px", width: "100%", maxWidth: "500px", maxHeight: "80vh", display: "flex", flexDirection: "column", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ padding: "20px 24px 16px", borderBottom: "1px solid rgba(0,0,0,0.1)", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <h5 style={{ margin: 0, fontWeight: 600, color: "#333" }}>{title}</h5>
          <button onClick={onClose} style={{ background: "none", border: "none", fontSize: "20px", cursor: "pointer", color: "#999", lineHeight: 1 }}>✕</button>
        </div>
        <div style={{ padding: "20px 24px", overflowY: "auto", flex: 1, fontSize: "13px", color: "#444", lineHeight: "1.7", whiteSpace: "pre-wrap" }}>
          {content}
        </div>
        <div style={{ padding: "16px 24px", borderTop: "1px solid rgba(0,0,0,0.1)", display: "flex", justifyContent: "flex-end" }}>
          <button onClick={onClose} style={{ padding: "9px 24px", borderRadius: "20px", border: "none", background: "rgba(200,200,200,0.7)", cursor: "pointer", fontSize: "13px", color: "#333" }}>ปิด</button>
        </div>
      </div>
    </div>
  );
}

// ── OTP Popup Modal ──────────────────────────────────────────
function OtpModal({ email, onVerified, onClose }) {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(60);

  useEffect(() => {
    if (countdown <= 0) return;
    const t = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(t);
  }, [countdown]);

  const handleResend = async () => {
    setError("");
    setOtp("");
    try {
      await fetch(`${API}/api/register/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email })
      });
      setCountdown(60);
    } catch {}
  };

  const handleVerify = async () => {
    if (otp.length !== 6) { setError("กรุณากรอก OTP 6 หลัก"); return; }
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API}/api/register/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      onVerified();
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}
      onClick={onClose}
    >
      <div
        style={{ background: "rgba(255,255,255,0.95)", backdropFilter: "blur(20px)", borderRadius: "20px", width: "100%", maxWidth: "360px", padding: "28px 24px", boxShadow: "0 20px 60px rgba(0,0,0,0.3)", textAlign: "center" }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{ fontSize: "40px", marginBottom: "8px" }}>📧</div>
        <h5 style={{ fontWeight: 600, color: "#333", marginBottom: "6px" }}>ยืนยันอีเมล</h5>
        <p style={{ fontSize: "13px", color: "#666", marginBottom: "20px" }}>
          ส่ง OTP ไปที่<br /><strong style={{ color: "#333" }}>{email}</strong><br />
          <span style={{ fontSize: "12px", color: "#999" }}>เช็คกล่องขาเข้า หรือ Spam</span>
        </p>

        <input
          type="text" value={otp} maxLength={6}
          onChange={e => { setOtp(e.target.value.replace(/\D/g, "")); setError(""); }}
          onKeyDown={e => e.key === "Enter" && handleVerify()}
          placeholder="000000"
          style={{
            width: "100%", padding: "12px", borderRadius: "12px",
            border: "2px solid " + (error ? "#ff6b6b" : "#ddd"),
            fontSize: "24px", letterSpacing: "10px", textAlign: "center",
            outline: "none", marginBottom: "8px", background: "rgba(255,255,255,0.8)"
          }}
          autoFocus
        />
        {error && <small style={{ color: "#ff6b6b", display: "block", marginBottom: "8px" }}>{error}</small>}

        <button
          onClick={handleVerify} disabled={loading}
          style={{ width: "100%", padding: "12px", borderRadius: "12px", border: "none", background: "#2d6a4f", color: "#fff", fontWeight: 600, fontSize: "14px", cursor: "pointer", marginBottom: "12px" }}
        >
          {loading ? "กำลังตรวจสอบ..." : "ยืนยัน OTP"}
        </button>

        <div style={{ fontSize: "13px" }}>
          {countdown > 0
            ? <span style={{ color: "#999" }}>ส่งอีกครั้งใน {countdown} วินาที</span>
            : <button onClick={handleResend} style={{ background: "none", border: "none", color: "#2d6a4f", cursor: "pointer", textDecoration: "underline", fontSize: "13px" }}>
                ส่ง OTP อีกครั้ง
              </button>
          }
        </div>

        <button onClick={onClose} style={{ marginTop: "10px", background: "none", border: "none", color: "#aaa", cursor: "pointer", fontSize: "12px" }}>
          ยกเลิก
        </button>
      </div>
    </div>
  );
}

// ── Register ─────────────────────────────────────────────────
function Register() {
  const navigate = useNavigate();
  const { lang, toggle } = useLanguage();

  const [form, setForm] = useState({ email: "", password: "", confirmPassword: "", agree: false });
  const [error, setError] = useState({});
  const [modal, setModal] = useState(null); // "terms" | "privacy" | "otp"
  const [consentTimestamp, setConsentTimestamp] = useState(null);
  const [passwordFocused, setPasswordFocused] = useState(false);
  const [loading, setLoading] = useState(false);

  const conditions = {
    minLength: form.password.length >= 8,
    upper: /[A-Z]/.test(form.password),
    lower: /[a-z]/.test(form.password),
    number: /[0-9]/.test(form.password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(form.password),
  };
  const passwordValid = Object.values(conditions).every(Boolean);
  const passwordsMatch = form.confirmPassword && form.password === form.confirmPassword;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "agree") setConsentTimestamp(checked ? nowThaiTime() : null);
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const validate = () => {
    let newError = {};
    if (!form.email) newError.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(form.email)) newError.email = "Invalid email";
    if (!passwordValid) newError.password = "Password does not meet security requirements";
    if (!passwordsMatch) newError.confirmPassword = "Passwords do not match";
    if (!form.agree) newError.agree = "You must agree to the terms";
    setError(newError);
    return Object.keys(newError).length === 0;
  };

  // กด Create Account → ส่ง OTP → เปิด popup
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/register/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: form.email })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      setModal("otp");
    } catch (err) {
      setError({ email: err.message });
    } finally {
      setLoading(false);
    }
  };

  // OTP ผ่านแล้ว → register จริง
  const handleOtpVerified = async () => {
    setModal(null);
    try {
      const res = await fetch(`${API}/api/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: form.email,
          password: form.password,
          termsAcceptedAt: consentTimestamp,
          privacyAcceptedAt: consentTimestamp,
        })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Register failed");

      const loginRes = await fetch(`${API}/api/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: form.email, password: form.password })
      });
      const loginData = await loginRes.json();
      if (!loginRes.ok) throw new Error(loginData.message || "Login failed");

      localStorage.setItem("token", loginData.token);
      navigate("/rooms");
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="login-bg">

      {/* LANG TOGGLE */}
      <button
        onClick={toggle}
        style={{ position: "fixed", top: 16, right: 16, background: "none", border: "none", cursor: "pointer", zIndex: 100 }}
        title={lang === "th" ? "Switch to English" : "เปลี่ยนเป็นภาษาไทย"}
      >
        {lang === "th" ? <FlagUS size={28} /> : <FlagTH size={28} />}
      </button>

      {modal === "terms" && (
        <TermsModal title={LEGAL_CONFIG.terms.title} content={buildText(LEGAL_CONFIG.terms)} onClose={() => setModal(null)} />
      )}
      {modal === "privacy" && (
        <TermsModal title={LEGAL_CONFIG.privacy.title} content={buildText(LEGAL_CONFIG.privacy)} onClose={() => setModal(null)} />
      )}
      {modal === "otp" && (
        <OtpModal
          email={form.email}
          onVerified={handleOtpVerified}
          onClose={() => setModal(null)}
        />
      )}

      <div className="text-center mb-3">
        <img src="/logo.png" width="90" alt="logo" />
      </div>

      <div className="glass-card">
        <h4 className="text-center mb-3">{t(lang,"createAccTitle")}</h4>

        <div className="input-group-glass" style={{ marginBottom: "12px" }}>
          <label>{t(lang,"emailLabel")}</label>
          <input name="email" type="email" value={form.email} onChange={handleChange} />
          <small className="text-danger">{error.email}</small>
        </div>

        <div className="input-group-glass" style={{ marginBottom: "4px" }}>
          <label>{t(lang,"passwordLabel")}</label>
          <input
            name="password" type="password" value={form.password}
            onChange={handleChange}
            onFocus={() => setPasswordFocused(true)}
            onBlur={() => setPasswordFocused(false)}
          />
        </div>

        {(passwordFocused || (form.password.length > 0 && !passwordValid)) && (
          <div style={{ fontSize: "12px", margin: "6px 0 8px", lineHeight: "20px", opacity: 0.9 }}>
            {[
              { key: "minLength", labelKey: "pwdMin" },
              { key: "upper",     labelKey: "pwdUpper" },
              { key: "lower",     labelKey: "pwdLower" },
              { key: "number",    labelKey: "pwdNumber" },
              { key: "special",   labelKey: "pwdSpecial" },
            ].map(({ key, labelKey }) => (
              <div key={key} style={{ color: conditions[key] ? "#0b6e00" : "#ff6b6b" }}>
                {conditions[key] ? "✓" : "•"} {t(lang, labelKey)}
              </div>
            ))}
          </div>
        )}
        <small className="text-danger" style={{ display: "block", marginBottom: "4px" }}>{error.password}</small>

        <div className="input-group-glass" style={{ marginBottom: "12px" }}>
          <label>{t(lang,"confirmPass")}</label>
          <input name="confirmPassword" type="password" value={form.confirmPassword} onChange={handleChange} />
          {form.confirmPassword && (
            <small style={{ color: passwordsMatch ? "#0b6e00" : "#ff6b6b", fontSize: "12px", display: "block", marginTop: "4px" }}>
              {passwordsMatch ? t(lang,"passMatch") : t(lang,"passNoMatch")}
            </small>
          )}
        </div>

        <div className="form-check mb-2">
          <input
            className="form-check-input" type="checkbox" name="agree"
            checked={form.agree} onChange={handleChange}
            style={{ width: "18px", height: "18px", border: "2px solid #333", borderRadius: "4px", cursor: "pointer", accentColor: "#333" }}
          />
          <label className="form-check-label" style={{ fontSize: "13px" }}>
            {t(lang,"agreeToThe")}{" "}
            <button type="button" onClick={() => setModal("terms")}
              style={{ background: "none", border: "none", padding: 0, color: "#0b6e00", textDecoration: "underline", cursor: "pointer", fontSize: "13px" }}>
              {t(lang,"termsOfUse")}
            </button>
            {" "}{t(lang,"andWord")}{" "}
            <button type="button" onClick={() => setModal("privacy")}
              style={{ background: "none", border: "none", padding: 0, color: "#0b6e00", textDecoration: "underline", cursor: "pointer", fontSize: "13px" }}>
              {t(lang,"privacyPol")}
            </button>
          </label>
          <small className="text-danger d-block">{error.agree}</small>
        </div>

        <button
          className="glass-btn-login" onClick={handleSubmit}
          disabled={loading || !passwordValid || !passwordsMatch || !form.agree}
        >
          {loading ? t(lang,"sendingOtp") : t(lang,"createAccBtn")}
        </button>
      </div>

      <div className="bottom-btn-wrapper">
        <Link to="/login" className="glass-btn outline-btn">{t(lang,"alreadyHaveAcc")}</Link>
      </div>
    </div>
  );
}

export default Register;
